export default __webpack_public_path__ + "static/media/EVENT26ASTACKr.49684c10.png";